export default {
  set(key: string, value: unknown) {
    localStorage.setItem(key, JSON.stringify({ data: value }));
  },
  get(key: string, defaultValue: unknown = null) {
    let value = null;
    try {
      const getValue = localStorage.getItem(key);
      if (getValue) value = JSON.parse(getValue);
    } catch (e) {
      if (localStorage[`${key}`]) {
        value = { data: localStorage.getItem(key) };
      } else {
        value = null;
      }
    }
    if (!value) {
      return defaultValue;
    }

    if (typeof value === 'object' && typeof value.data !== 'undefined') {
      return value.data;
    }
  },
  rm(key: string) {
    localStorage.removeItem(key);
  },
  flush() {
    localStorage.clear();
  },
};
